/**
 * FBR digital invoicing config (docs/FBR.md). Everything here is behind
 * `fbr.enabled` — a business that never registers for FBR integration never
 * sees any of it.
 */
import { z } from 'zod';
import { FBR_MODES } from '../constants.js';
export const upsertFbrConfigSchema = z.object({
    enabled: z.boolean().default(false),
    mode: z.enum(FBR_MODES).default('SANDBOX'),
    /** Write-only — never returned by the API once saved. */
    sandboxToken: z.string().min(1).max(2000).optional(),
    productionToken: z.string().min(1).max(2000).optional(),
    sellerNTNCNIC: z.string().max(20).optional(),
    sellerBusinessName: z.string().max(200).optional(),
    sellerProvince: z.string().max(60).optional(),
    sellerAddress: z.string().max(400).optional(),
    taxOfficeName: z.string().max(120).optional(),
    defaultSaleType: z.string().max(80).optional(),
    defaultScenarioId: z.string().max(20).optional(),
    posServiceFeeEnabled: z.boolean().default(false),
    posServiceFeePaisa: z.number().int().min(0).default(100),
    blockSaleOnFailure: z.boolean().default(false),
    autoReprintOnAccept: z.boolean().default(true),
});
export const listFbrSubmissionsQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    status: z.string().optional(),
    shopId: z.string().optional(),
});
//# sourceMappingURL=fbr.js.map